import {updateDeliveryContactNumber} from '../../address-actions';

export default contactNumber => (dispatch) => {
  dispatch(updateDeliveryContactNumber(contactNumber));
};
